import { Redirect } from 'react-router-dom/cjs/react-router-dom.min';

import { ROUTES } from '#constants/routes';

export const getRedirect = route => <Redirect to={ROUTES[route].path} />;
